<template>
  <div
    v-if="company"
    class="py-1 px-2 row mx-1 my-2 company-card"
    :class="[checkbox ? 'checked' : '']"
    @click.prevent="!isSelected ? (checkbox = !checkbox) : ''"
  >
    <b-form-checkbox
      v-show="!isSelected"
      :id="'checkbox-' . company"
      v-model="checkbox"
      name="checkbox"
      class="col-1"
    />
    <h1 class="company-title col-11 col-lg-4 my-auto">
      {{ company.company.title }}
    </h1>
    <h1 class="title col-12 col-lg-3 my-auto">
      <span style="font-size: 0.9rem">{{ $t('generic.cif', 'CIF') }}:</span>
      {{ company.company.number }}
    </h1>
    <h1 class="contact col-12 col-lg-3 my-auto">
      <font-awesome-icon
        icon="phone-square"
      />
      <span style="font-size: 0.9rem; color: #777">{{ $t('generic.phone', 'Phone') }}:</span>
      {{ company.company.phone }}
    </h1>
  </div>
</template>

<script>
export default {
  props: {
    company: {
      type: Object,
      default: null
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    isAssigned: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checkbox: false
    }
  },
  mounted() {
    this.checkbox = this.isAssigned;
  },
  methods: {
    selectCompany(isSelected) {
      this.checkbox = isSelected;
    }
  }
}
</script>

<style lang="scss">
  h1.company-title {
    color: #009090;
    font-size: 0.9rem !important;
    text-transform: uppercase;
    margin-bottom: 0;
  }

  h1.title {
    color: #999;
    font-size: 1rem !important;
    margin-bottom: 0;
  }

  h1.contact {
    color: rgb(80, 80, 80);
    font-size: 1rem !important;
    margin-bottom: 0;
  }

  .company-card {
    background: white;
    cursor: pointer;
    box-shadow: 3px 3px 20px 0px rgba(210,210,210,1);

    // &:hover {
    //   box-shadow: 3px 3px 20px 0px rgba(210,210,210,1);
    // }
  }

  .checked {
      box-shadow: inset 3px 3px 15px 0px rgba(210,210,210,1);
    }
</style>
